/**
 * Note list configuration.
 * Mirrors the other system-created entity list configs. Notes are created via
 * the note composer rather than the generic create form, so there are no
 * create properties here.
 *
 * Columns: Note (object_name preview) · Author (creator) · Updated.
 */

import type { ListPageConfig } from '../../core/types';

export const noteListConfig: ListPageConfig = {
  entityType: 'ahoy_note',
  title: 'Note',
  pluralTitle: 'Notes',

  columns: [
    { kind: 'object_name', sortable: true, width: 360 },
    { kind: 'association', name: 'ahoy_note_to_creator' },
    { kind: 'property', name: 'ahoy_updated_at' },
  ],

  createProperties: [],
  createAssociations: [],
  metrics: [],

  // Most-recently-updated notes first.
  defaultFilters: {
    page: 1,
    page_size: 20,
    sort: 'ahoy_updated_at',
    order: 'desc',
  },

  showTimeFilter: false,
};
